import Vue from 'vue';
import moment from 'moment';

Vue.filter('prettyDate', function (value, hours = false) {
    if (value && hours) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm');
    } else if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
    } else return '---';
});